import styled, { css } from 'styled-components';

export const PopupTitleContainer = styled.div`
  padding: 16px 0;
  box-shadow: 0px -1px 0px 0px #e3e6ea inset;
`;

export const PopupWrapper = styled.div`
  width: 800px;
  max-width: 90vw;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.16);
`;

export const PopupTitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 24px;
`;

export const PopupTitle = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
`;

export const PopupTitleSpan = styled.span`
  margin: 0;

  &:before {
    content: '\\e91f';
    font-family: 'Icomoon';
    cursor: pointer;
  }
`;

export const Container = styled.div`
  min-height: 200px;
`;

export const extendLoaderStyle = css`
  height: 16px;
  width: 16px;
  border: 1px solid #f3f3f3;
  border-top: 3px solid #3498db;
  margin: 0;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: end;
  border-top: 1px solid #d9dbdf;
  gap: 8px;
  padding: 16px;
`;

export const extendGrayButtonStyle = css`
  width: 96px;
  border-radius: 8px;
  border: 1px solid #d9dbdf;
  background: #f1f4f6;
  color: #484848;
  padding: 7px 10px;
`;

export const extendBlueButtonStyle = css`
  min-width: 96px;
  border-radius: 8px;
  border: 1px solid #e3e6ea;
  background: #0070cd;
  color: #fff;
  padding: 7px 10px;
`;

export const extendSmallBlueButtonStyle = css`
  min-width: 80px;
  border-radius: 8px;
  border: 1px solid #e3e6ea;
  background: #0070cd;
  color: #fff;
  padding: 7px 10px;
  font-size: 13px;
`;

export const extendSmallRedButtonStyle = css`
  min-width: 80px;
  border-radius: 8px;
  border: 1px solid #e3e6ea;
  background: #fff;
  color: #db3226;
  padding: 7px 10px;
  font-size: 13px;
`;

export const extendAddedButtonStyle = css`
  min-width: 80px;
  border-radius: 8px;
  border: 1px solid #d9dbdf;
  background: #f1f4f6;
  color: #9c9c9c;
  padding: 7px 10px;
  font-size: 13px;
`;

export const ItemsContainer = styled.div`
  max-height: 400px;
  overflow: auto;
  ::-webkit-scrollbar {
    width: 6px;
  }
  ::-webkit-scrollbar-thumb {
    background: #9c9c9c;
    border-radius: 15px;
  }
`;

export const ItemContainer = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1.2fr 0.8fr 130px;
  box-shadow: 0px -1px 0px 0px #e3e6ea inset;
`;

export const ItemWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-right: 1px solid #e3e6ea;
  font-size: 13px;
  color: #484848;
  &:last-child {
    border-right: unset;
    justify-content: center;
  }
`;

export const EmptyState = styled.p`
  padding: 32px 24px;
  margin: 0;
  text-align: center;
  color: #9c9c9c;
  font-size: 14px;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 48px 24px;
`;

export const Subtitle = styled.p`
  margin: 0;
  padding: 12px 24px 0;
  font-size: 13px;
  color: #9c9c9c;
`;
